export enum RefreshPageKeys {
    DataCheckinJob = 'dataCheckinJob',
    Workflow = 'workflow',
    Notifications = 'notifications',
}
